import { createSlice } from "@reduxjs/toolkit";
import { reset } from "../actions";

const profileSlice = createSlice({
  name: "profile",
  initialState: { version: "1.0" },
  reducers: {
    setProfile(state, action) {
      // console.log("hey!!!!!!!!!!!!");
      return { ...state, ...action.payload };
    },
  },
  extraReducers(builder) {
    builder.addCase(reset, (state, action) => {
      return {};
    });
  },
});

export const { setProfile } = profileSlice.actions;
export const profileReducer = profileSlice.reducer;
